import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

/** Builder (admin) list: every substance of the base table, whatever its Public flag. */
async function getInjectionSubstances() {
    const { data } = await supabaseClient
        .from("injection_substances")
        .select("injection_substance, is_public, created_by")
        .order("injection_substance")
        .throwOnError();
    return data ?? [];
}

export const injection_substances_key = ["injection-substances"];

export const injectionSubstancesQueryOptions = () => {
    return queryOptions({
        queryKey: injection_substances_key,
        queryFn: getInjectionSubstances,
    });
};

export function useInjectionSubstancesQuery() {
    return useQuery(injectionSubstancesQueryOptions());
}
